<div id="chart">
	<div class="labels gapped">
		<div class="labels">
			<mat-label>Daily</mat-label>
			<mat-slide-toggle
				slot="start"
				[checked]="monthlyToggle"
				(click)="monthlyToggleChangeFunc()"></mat-slide-toggle>
			<mat-label>Monthly</mat-label>
		</div>

		@if (!monthlyToggle) {
<div
			class="labels"
		>
			<mat-label>Current month</mat-label>
			<mat-slide-toggle
				slot="start"
				[checked]="dailyToggle"
				(click)="dailyToggleChangeFunc()"></mat-slide-toggle>
			<mat-label>Last 30 days</mat-label>
		</div>
}

		@if (monthlyToggle) {
<div
			class="labels"
		>
			<mat-button-toggle-group
				(change)="timeFrameChange($event)"
				[value]="selectedTimeframe">
				<mat-button-toggle value="3">3 months</mat-button-toggle>
				<mat-button-toggle value="6">6 months</mat-button-toggle>
				<mat-button-toggle value="12">12 months</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
}
	</div>
	@if (graphLoaded) {
<apx-chart
	
		#chart
		[series]="chartOptions.series"
		[chart]="chartOptions.chart"
		[responsive]="chartOptions.responsive"
		[stroke]="chartOptions.stroke"
		[xaxis]="chartOptions.xaxis"
		[yaxis]="chartOptions.yaxis"
		[grid]="chartOptions.grid"
		[title]="chartOptions.title"></apx-chart>
}
</div>
